import { Component, Vue } from "vue-property-decorator";

declare module "vue/types/vue" {
  interface Vue {
    cleanUpEmptyStrings(obj: any): any;
  }
}

@Component
export default class VueMethods extends Vue {
  public cleanUpEmptyStrings(obj: Record<string, any>): Record<string, any> {
    const map = new Map(Object.entries(obj));
    map.forEach((value, key) => {
      if (value === "") {
        obj[key] = undefined;
      }
    });
    return obj;
  }
}
